import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'onink';
  size?: 'sm' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'sm',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-[0.5em] font-body font-semibold rounded-full no-underline cursor-pointer transition-all duration-200 ease-out';
  const sizeStyles = {
    sm: 'py-[0.6em] px-[1.15em] text-[0.82rem]',
    lg: 'py-[0.95em] px-[1.9em] text-[1rem]'
  };
  const variantStyles = {
    primary: 'border border-teal bg-teal text-paper-on hover:bg-teal-hover hover:-translate-y-[1px] hover:shadow-[0_8px_22px_-12px_rgba(46,94,90,0.7)]',
    onink: 'border border-paper bg-paper text-ink hover:bg-white hover:-translate-y-[1px] hover:shadow-[0_8px_22px_-12px_rgba(0,0,0,0.5)]'
  };
  return <a className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${className}`} target="_blank" rel="noopener noreferrer" {...props} data-id="element-11">
      {children}
    </a>;
}